import { SITE_PATHS } from '../../../shared/siteRoutes';

/**
 * Element id named by a URL hash, or null when there is none. The hash is
 * visitor-controlled, so a malformed escape (for example "#%E0%A4%A") falls back
 * to the raw text instead of throwing.
 */
export function hashTargetId(hash: string): string | null {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!raw) return null;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/**
 * The public marketing pages (the SiteLayout routes): the only pages that may load analytics.
 * Never the merchant dashboard (/app), Shopify admin (/shopify/app), admin, login or the wizard.
 */
export { SITE_PATHS };

export function isSitePath(pathname: string): boolean {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return SITE_PATHS.includes(path);
}

/** Set on window by lib/analytics once Google tags may be in this document (site pages only). */
export interface SiteTagsHandle {
  /** Stops GA4 from sending anything more from this document. */
  stop(): void;
}

declare global {
  interface Window {
    __perzoSiteTags?: SiteTagsHandle;
  }
}

export function siteTagsActive(): boolean {
  return typeof window !== 'undefined' && Boolean(window.__perzoSiteTags);
}

/** Where a "Get started" / "Get early access" call to action leads: the early-access form while installs are closed. */
export function getStartedPath(installOpen: boolean): string {
  return installOpen ? '/get-started' : '/get-started#early-access';
}
